"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ConfigProvider_1 = require("../ConfigProvider");
var utils_1 = require("../utils");
var icons_1 = require("../icons");
var env_1 = require("../Link/env");
function Alert(props) {
    var className = props.className, message = props.message, desc = props.desc, icon = props.icon, _a = props.type, type = _a === void 0 ? 'default' : _a, closable = props.closable, rootHtmlProps = props.rootHtmlProps, style = props.style, rest = tslib_1.__rest(props, ["className", "message", "desc", "icon", "type", "closable", "rootHtmlProps", "style"]);
    var _b = react_1.useState(true), visible = _b[0], setVisible = _b[1];
    var prefix = ConfigProvider_1.usePrefix('alert');
    var typePrefix = utils_1.concat(prefix, type);
    var iconPrefix = utils_1.concat(prefix, 'icon');
    var contentPrefix = utils_1.concat(prefix, 'content');
    var closePrefix = utils_1.concat(prefix, 'close');
    var descPrefix = utils_1.concat(contentPrefix, 'desc');
    var innerIcon = icon === true ? getIconByType(type) : icon;
    var innerCloseIcon = getCloseIcon(closable);
    function handleClose() {
        var _a;
        if (closable === true) {
            setVisible(false);
            return;
        }
        if (typeof closable === 'object') {
            setVisible(false);
            (_a = closable.onClose) === null || _a === void 0 ? void 0 : _a.call(closable);
        }
    }
    var cls = classnames_1.default(className, prefix, typePrefix, desc && utils_1.concat(prefix, 'has-desc'), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className);
    if (visible === false) {
        return null;
    }
    return (react_1.default.createElement(env_1.EnvProvider, { isBlue: type === 'info' },
        react_1.default.createElement("div", tslib_1.__assign({ className: cls, style: tslib_1.__assign(tslib_1.__assign({}, style), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.style) }, rest),
            icon && react_1.default.createElement("div", { className: iconPrefix }, innerIcon),
            react_1.default.createElement("div", { className: contentPrefix },
                message,
                desc && react_1.default.createElement("div", { className: descPrefix }, desc)),
            react_1.default.createElement("div", { className: utils_1.concat(prefix, 'spacer') }),
            innerCloseIcon && react_1.default.createElement("span", { className: closePrefix, onClick: handleClose }, innerCloseIcon))));
}
exports.default = Alert;
function getIconByType(type) {
    switch (type) {
        case 'info':
        default:
            return react_1.default.createElement(icons_1.InfoIcon, null);
        case 'success':
            return react_1.default.createElement(icons_1.CheckCircleIcon, null);
        case 'error':
            return react_1.default.createElement(icons_1.CloseCircleIcon, null);
        case 'warning':
            return react_1.default.createElement(icons_1.TipIcon, null);
    }
}
function getCloseIcon(closable) {
    var _a;
    if (closable === true) {
        return react_1.default.createElement(icons_1.CloseIcon, null);
    }
    if (typeof closable === 'object') {
        return (_a = closable.icon) !== null && _a !== void 0 ? _a : react_1.default.createElement(icons_1.CloseIcon, null);
    }
    return null;
}
//# sourceMappingURL=index.js.map